import React, { useEffect, useContext } from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FourOhFourError, StaticContext } from '@sm/webassets';

import { HomePage, DocsPage, FAQPage, TOUPage, BuildAPrivateAppPage, BuildAPublicAppPage } from './pages';

const DeveloperWebRouter = ({ history }) => {
  const {
    environment: { domain },
  } = useContext(StaticContext);

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  // Hide usabilla for all pages - each individual page will set usabilla configs and show if enabled
  // Note the load of usabilla hides the button so this code is included if usabilla has already been loaded
  if (typeof window !== 'undefined' && window && window.usabilla_live) {
    window.usabilla_live('virtualPageView');
    window.usabilla_live('hide');
  }

  return (
    <Switch>
      <Route path="/developer/" component={HomePage} exact />
      <Route path="/developer/home" component={HomePage} exact />
      <Route path="/developer/api/v3" component={DocsPage} exact />
      <Route path="/developer/faq" component={FAQPage} exact />
      <Route path="/developer/tou" component={TOUPage} exact />
      <Route path="/developer/build-a-private-app" component={BuildAPrivateAppPage} exact />
      <Route path="/developer/build-a-public-app" component={BuildAPublicAppPage} exact />

      <Route
        path="/developer/user/account"
        exact
        component={() => {
          window.location.href = `https://www.${domain}.com/user/account`;
          return null;
        }}
      />
      <Route
        path="/developer/user/account/select"
        exact
        component={() => {
          window.location.href = `https://www.${domain}.com/user/account/select?ep=https://developer.${domain}.com`;
          return null;
        }}
      />
      <Route
        path="/developer/team/libraries"
        exact
        component={() => {
          window.location.href = `https://www.${domain}.com/team/libraries`;
          return null;
        }}
      />
      <Route
        path="/developer/addressbook"
        exact
        component={() => {
          window.location.href = `https://www.${domain}.com/addressbook`;
          return null;
        }}
      />
      <Route
        path="/developer/user/sign-out"
        exact
        component={() => {
          window.location.href = `https://www.${domain}.com/user/sign-out?ep=https://developer.${domain}.com`;
          return null;
        }}
      />

      <Route component={FourOhFourError} />
    </Switch>
  );
};

DeveloperWebRouter.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(DeveloperWebRouter);
